import { handleActions } from 'redux-actions';
import { SessionId, InstantMessageMap, Permissions } from 'types';
import {
    SetLanguageRequestAction,
    SetLanguageSuccessAction,
    LoginRequestAction,
    LoginSuccessAction,
    LoginFailureAction,
    LogoutAction,
    SetTopBarVisibilityAction,
    InstantMessagesReceivedAction,
    InstantMessageDismissedAction,
} from 'actions/shellActions';

export type State = Readonly<{
    language: string;
    loadingLanguage: string | null;
    loginPending: boolean;
    sessionId: SessionId | null;
    loginName: string | null;
    loginError: Error | null;
    loggedIn: boolean;
    admin: boolean;
    topBar: boolean;
    messages: Readonly<InstantMessageMap>;
    permissions: Readonly<Permissions>;
}>;

export const initialState = Object.freeze<State>({
    language: '',
    loadingLanguage: null,
    loginPending: false,
    sessionId: null,
    loginName: null,
    loginError: null,
    loggedIn: false,
    admin: false,
    topBar: true,
    messages: {},
    permissions: {} as Permissions,
});

export type ReducerAction =
    SetLanguageRequestAction
    | SetLanguageSuccessAction
    | LoginRequestAction
    | LoginSuccessAction
    | LoginFailureAction
    | LogoutAction
    | SetTopBarVisibilityAction
;
export type Reducer = (state: State, action: ReducerAction) => State;

export const shellReducer: Reducer = handleActions({
    SET_LANGUAGE_REQUEST(state: State, action: SetLanguageRequestAction) {
        const language = action.payload;
        return {
            ...state,
            loadingLanguage: language,
        };
    },

    SET_LANGUAGE_SUCCESS(state: State, action: SetLanguageSuccessAction) {
        const language = action.payload;
        return {
            ...state,
            language,
            loadingLanguage: null,
        };
    },

    SET_TOP_BAR_VISIBILITY(state: State, action: SetTopBarVisibilityAction) {
        const visible = action.payload;
        return {
            ...state,
            topBar: visible,
        };
    },

    LOGIN_REQUEST(state: State, action: LoginRequestAction) {
        const { username } = action.payload;
        return {
            ...state,
            loginPending: true,
            loginName: username,
            loginError: null,
        };
    },

    LOGIN_SUCCESS(state: State, action: LoginSuccessAction) {
        return {
            ...state,
            ...action.payload,
            loginPending: false,
            loginError: null,
            loggedIn: true,
        };
    },

    LOGIN_FAILURE(state: State, action: LoginFailureAction) {
        const err = action.payload;
        return {
            ...state,
            loginPending: false,
            loginError: err,
        };
    },

    LOGOUT(state: State, action: LogoutAction) {
        return {
            ...state,
            sessionId: null,
            loginName: null,
            loggedIn: false,
            admin: false,
            permissions: {},
        };
    },

    INSTANT_MESSAGES_RECEIVED(state: State, action: InstantMessagesReceivedAction) {
        return {
            ...state,
            messages: {
                ...state.messages,
                ...action.payload,
            },
        };
    },

    INSTANT_MESSAGE_DISMISSED(state: State, action: InstantMessageDismissedAction) {
        const messageId = action.payload;
        if (!messageId) {
            return {
                ...state,
                messages: {},
            };
        }
        const messages: InstantMessageMap = { ...state.messages };
        delete messages[messageId];
        return {
            ...state,
            messages,
        };
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/shellReducer.ts